import {
  Component,
  ChangeDetectorRef,
  EventEmitter,
  effect,
  inject,
  input,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ConfigService } from '@app/finxone-web-frontend/app/lib/services/config-service/config-service.service';
import { currencyToCircleFlag } from '@app/finxone-web-frontend/app/lib/utils/template/handlebar-helpers/currency-to-flag.utils';
import {
  baseCssConfigStyle,
  DropdownMenuDirection,
  InputLabelOptions,
  isMultiCurrencyAccountInfoType,
} from '@finxone-platform/shared/sys-config-types';
import { DropdownListingInterface } from '../../widgets/accounts-context-dropdown-widget/accounts-context-dropdown-widget.component';

@Component({
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false,
  selector: 'finxone-web-frontend-accounts-context-dropdown',
  templateUrl: './accounts-context-dropdown.component.html',
  styleUrls: [
    '../../widgets/accounts-context-dropdown-widget/accounts-context-dropdown-widget.component.scss',
  ],
})
export class AccountsContextDropdownComponent {
  private readonly configService = inject(ConfigService);
  private cssVars: Record<string, string> = {};

  @Input() dropdownListing: DropdownListingInterface[] = [];
  @Input() dropdownTemplate = '';
  @Input() leftIcon = '';
  @Input() rightIcon = '';
  @Input() renderedContent = '';
  @Input() textContent = '';
  @Input() showFlag = false;
  @Input() isScrollable = true;
  @Input() isScrollPeekEnabled = false;
  @Input() visibleItemsCount = 5;
  @Input() dropdownMenuDirection = DropdownMenuDirection.AUTO;
  @Input() selectedAccount: DropdownListingInterface | null = null;
  @Input() currentInputStyle: baseCssConfigStyle = {};
  @Input() leftIconStyle: baseCssConfigStyle = {};
  @Input() rightIconStyle: baseCssConfigStyle = {};
  @Input() noRecordsTemplate = 'No data found';
  @Input() footerTemplate?: TemplateRef<unknown> | null = null;
  @Input() footerFloatingThreshold?: number | null = null;
  @Input() labelType: InputLabelOptions = InputLabelOptions.STATIC;

  public InputLabelOptions = InputLabelOptions;
  public formInputId = input<string>('accountId');
  public accountContextFormGroup = input<FormGroup<Record<string, FormControl>>>();

  @Output() selectionChanged = new EventEmitter<DropdownListingInterface>();
  @Output() scrolled = new EventEmitter<void>();

  public isMultiCurrencyAccountInfoType = isMultiCurrencyAccountInfoType;
  public borderRadiusClass = '';
  public dropdownOpened = false;

  constructor() {
    effect(() => {
      const globalCssVariables = this.configService.globalCssVariables();
      if (globalCssVariables) {
        this.cssVars = globalCssVariables;
        const radiusClass = this.getCssVariableValue('--inputFieldBorderRadiusClass');
        this.borderRadiusClass = !radiusClass || radiusClass === 'none' ? '' : radiusClass;
      }
    });
  }

  private getCssVariableValue(variableName: string): string {
    return this.cssVars[variableName];
  }

  public onAccountSelection(account: DropdownListingInterface) {
    this.selectedAccount = account;
    this.selectionChanged.emit(account);
    if (this.accountContextFormGroup())
      this.accountContextFormGroup()?.get(this.formInputId())?.setValue(account?.accountId);
  }

  public onToggleDropdown(opened: boolean) {
    this.dropdownOpened = opened;
  }

  public handleChildScroll() {
    this.scrolled.emit();
  }

  public getCountryFlag(currency_code: string | undefined): string {
    if (currency_code) {
      return currencyToCircleFlag(currency_code, '26px');
    }
    return '';
  }
}
